import { render, staticRenderFns } from "./AutoFeeds.vue?vue&type=template&id=3e4c5b52"
import script from "./AutoFeeds.vue?vue&type=script&lang=js"
export * from "./AutoFeeds.vue?vue&type=script&lang=js"
import style0 from "./AutoFeeds.vue?vue&type=style&index=0&id=3e4c5b52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports